import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65m2.22 2.65h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65m2.22 2.65h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.559 36.8l5.3-5.3-5.3-5.3m0-4.4l5.3-5.3-5.3-5.3M39 16.5h-8.28c-1.24 0-2.36.5-3.18 1.32L15.18 30.18c-.82.82-1.94 1.32-3.18 1.32H6m12.18-10.68l-3-3A4.474 4.474 0 0012 16.5H6m33 15h-8.28c-1.24 0-2.36-.5-3.18-1.32l-3-3"
  }))
};
export var Shuffle = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});